import React from 'react';
import Header from '../../components/Header';
import ConditionalRadioButtons from '../../container/Activity/conditionalRadioButtons';
import InformationButton from '../../components/informationButton';
import Footer from '../../components/footer';
import navigationBackground from '../../../assets/Images/navigationBackground.png';
import MetaHelmet from '../../components/MetaHelmet';

const Activity = () => (
  <>
    <MetaHelmet
      title="Activity"
      description="Explore how your treatment approach can influence the progression of kidney disease and benefit your patients."
    />
    <div
      className="background-header"
      style={{
        backgroundImage: `url(${navigationBackground})`,
      }}
    >
      <Header showLogo={true} />
    </div>
    <InformationButton />
    <ConditionalRadioButtons />
    <Footer />
  </>
);

export default Activity;
